import {Component, computed, ref, VNode} from "vue";
import { HistoryState, LocationQueryRaw } from "vue-router";

type DialogProps = {
    title?: string,
    titleComp?: VNode,
    description?: string,
    descriptionComp?: VNode,
    props?: object,
    emits?: string[] | Record<string, (...args: any[]) => void>;
    component?: Component,
    footerComponent?: VNode,
    detailUrl?: string | {
        query?: LocationQueryRaw;
        hash?: string;
        path?: string;
        replace?: boolean;
        force?: boolean;
        state?: HistoryState;
        name?: string;
        params?: any
    },
    easyClose?: boolean,
    padding?: 'default' | 'none'
    size?: 'xs' | 'sm' | 'md' | 'lg'
}

export type DialogResponse<T> = {
    finished: boolean
    cancelled: boolean
    result?: T
}

interface State {
    dialog: DialogProps
    resolve?: <T>(value: DialogResponse<T>) => void | null,
}

const state = ref<State>({
    dialog: {},
    resolve: null
})

function useDialog() {
    return {
        _dialog: computed(() => state.value.dialog),
        dialog: dialog,
        closeDialog: closeDialog,
    }
}

interface State {
    dialog: DialogProps
    resolve?: <T>(value: DialogResponse<T>) => void | null,
}

function dialog<T>(dialog: DialogProps): Promise<DialogResponse<T>> {
    if (dialog.easyClose == null) dialog.easyClose = true
    if (dialog.size == null) dialog.size = 'md'
    const promise = new Promise<DialogResponse<T>>((resolve, reject): void => {
        state.value.resolve = resolve as (<T>(value: DialogResponse<T>) => void);
    });
    state.value.dialog = dialog;
    return promise;
}

function closeDialog(finished: boolean, result?: any | null) {
    if (finished && state.value.resolve) {
        state.value.resolve({
            cancelled: false,
            finished: true,
            result: result
        } as DialogResponse<any>)
    }
    if (!finished && state.value.resolve) {
        state.value.resolve({
            cancelled: true,
            finished: false,
            result: null
        } as DialogResponse<any>)
    }
    state.value.dialog = {};
    state.value.resolve = null;
}

export {useDialog}




